/** Convert API validation details into safe, renderable text. */
export function apiErrorMessage(detail, fallback = "Something went wrong. Please try again.") {
  const text = (value, depth = 0) => {
    if (depth > 3 || value == null) return "";
    if (typeof value === "string") return value.trim();
    if (Array.isArray(value)) return value.slice(0, 5).map((item) => text(item, depth + 1)).filter(Boolean).join(" ");
    if (typeof value === "object") return text(value.msg ?? value.message ?? value.detail, depth + 1);
    return "";
  };
  return text(detail).slice(0, 1000) || fallback;
}
